import { DATE_MDY, FORMAT_DATE, IS_NOT_NULL_OR_UNDEFINED, TO_DOLLARS } from '../../utils';
import { BID_DISPLAY_STATUS_CONSTANTS, BID_STATUS_UUID } from '../constants';
import { BidHistories, CarrierBidActivity, CarrierBidResponse } from '../dtos';

export const CARRIER_BID_ACTIVITY = (
	carrierBidResponse: CarrierBidResponse
): CarrierBidActivity[] => {
	const { bidHistoryList, customer, bidStatus, quoteLastModified, bidAmount, winningBidId, bidId } =
		carrierBidResponse;
	const activityList = [] as CarrierBidActivity[];

	try {
		if (IS_NOT_NULL_OR_UNDEFINED(bidHistoryList)) {
			let firstBidHistory = null as BidHistories;
			bidHistoryList.forEach((bidHistory, index) => {
				const activity = {} as CarrierBidActivity;
				activity.timestamp = FORMAT_DATE(bidHistory.created, 'MM/DD HH:mm');
				activity.pickupDate = DATE_MDY(bidHistory.pickupDate);
				activity.deliveryDate = DATE_MDY(bidHistory.deliveryDate);
				activity.amount = TO_DOLLARS(bidHistory.amount);
				if (index == 0) {
					activity.message = `${customer.businessName} created Quote`;
					firstBidHistory = bidHistory;
				} else if (
					index == bidHistoryList.length - 1 &&
					bidHistory.sourceType == 'CUSTOMER' &&
					BID_STATUS_UUID[bidStatus] == BID_DISPLAY_STATUS_CONSTANTS.CANCELLED
				) {
					activity.message = `${customer.businessName} cancelled Quote`;
					activity.pickupDate = null;
					activity.deliveryDate = null;
				} else {
					if (bidHistory.sourceType == 'CUSTOMER') {
						if (isBidUpdated(firstBidHistory, bidHistory)) {
							activity.message = `${customer.businessName}' updated offer`;
						} else {
							activity.message = `${customer.businessName}'s offer`;
						}
					} else {
						if (isBidUpdated(firstBidHistory, bidHistory)) {
							activity.message = 'You updated offer';
						} else {
							activity.message = 'You accepted offer';
						}
					}
				}
				activityList.push(activity);
			});
		}
		if (
			BID_STATUS_UUID[bidStatus] == BID_DISPLAY_STATUS_CONSTANTS.SELECTED &&
			bidId == winningBidId
		) {
			activityList.push({
				timestamp: FORMAT_DATE(quoteLastModified, 'MM/DD HH:mm'),
				amount: null,
				pickupDate: null,
				deliveryDate: null,
				message: 'Your offer was selected',
			});
		}
	} catch (error) {
		console.log('CARRIER_BID_ACTIVITY error: ', error);
	}

	return activityList;
};

const isBidUpdated = (firstBidHistory: BidHistories, currentBidHistory: BidHistories): boolean => {
	let result = false;
	if (
		firstBidHistory.pickupDate != currentBidHistory.pickupDate ||
		firstBidHistory.deliveryDate != currentBidHistory.deliveryDate ||
		firstBidHistory.amount != currentBidHistory.amount
	) {
		result = true;
	}
	return result;
};
